import React, { useState, useEffect } from 'react';
import MapIntegration from './Mapintegration'; // Import your MapIntegration component

const MapWithAddress = ({ address, mapheight }) => {
    const [coordinates, setCoordinates] = useState(null);

    useEffect(() => {
        const fetchCoordinates = async () => {
            try {
                const response = await fetch(
                    `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
                        address
                    )}&key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}`
                );

                const data = await response.json();

                if (data.results && data.results[0]) {
                    const { lat, lng } = data.results[0].geometry.location;
                    setCoordinates({ lat, lng });
                } else {
                    console.error("Geocoding failed:", data.error_message || "No results found");
                }
            } catch (error) {
                console.error("Error fetching geocode data:", error);
            }
        };

        fetchCoordinates();
    }, [address]);

    return (
        <div style={{ width: '100%', height: mapheight ? mapheight : '200px' }}>
            {coordinates ? (
                <MapIntegration latitude={coordinates.lat} longitude={coordinates.lng} />
            ) : (
                <p>Please add your location.</p>
            )}
        </div>
    );
};

export default MapWithAddress;
